import classNames from 'classnames/bind';
import styles from './CrmPaginationInternal.module.scss';
import {useTranslation} from "react-i18next";

export interface ICrmPaginationInternalProps {
    onFirstPageClicked: ()=>void;
    onPreviousPageClicked: ()=>void;
    onNextPageClicked: ()=>void;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    offset: number;
    pageSize: number;
    totalRecords: number;
    showDetails: boolean;
}

export function CrmPaginationInternal(props: ICrmPaginationInternalProps) {
    const { t } = useTranslation();
    const firstRecord = props.totalRecords === 0 ? 0 : props.offset + 1;
    const lastRecord = Math.min(props.offset + props.pageSize, props.totalRecords);
    const currentPage = Math.floor(props.offset / props.pageSize) + 1;
    const totalPages = Math.max(1, Math.ceil(props.totalRecords / props.pageSize));

    return (<div className={styles.crmPagination}>
        {props.showDetails && <>
            <span className={styles.pageSummary}>
                {t("showing-records", {first: firstRecord, last: lastRecord, total: props.totalRecords})}
            </span>
            <span className={styles.pageStatus}>
                {t("page-of", {current: currentPage, total: totalPages})}
            </span>
        </>}
        <div className={styles.pageActions}>
            <button type="button" className={styles.pageNavButton}
                    onClick={props.onFirstPageClicked} disabled={!props.hasPreviousPage}>{t("first")}</button>
            <button type="button" className={styles.pageNavButton}
                    onClick={props.onPreviousPageClicked} disabled={!props.hasPreviousPage}>{t("prev")}</button>
            <button type="button" className={styles.pageNavButton}
                    onClick={props.onNextPageClicked} disabled={!props.hasNextPage}>{t("next")}</button>
        </div>
    </div>);
}
